export const appHead = {"meta":[{"name":"viewport","content":"width=device-width, initial-scale=1"},{"charset":"utf-8"}],"link":[{"rel":"icon","type":"image/png","href":"/favicon/favicon-16.png","sizes":"16x16"},{"rel":"icon","type":"image/png","href":"/favicon/favicon-32.png","sizes":"32x32"},{"rel":"icon","type":"image/png","href":"/favicon/favicon-152.png","sizes":"152x152"},{"rel":"icon","type":"image/png","href":"/favicon/favicon-196.png","sizes":"196x196"},{"rel":"preconnect","href":"https://policy.app.cookieinformation.com"},{"rel":"preconnect","href":"https://assets.lexascms.com"},{"rel":"preload","as":"font","type":"font/woff2","crossorigin":"anonymous","href":"/fonts/figtree-normal-latin.woff2"}],"style":[],"script":[{"tagPriority":"critical","innerHTML":"(function(w,d,src,evs,now){\nvar dl=w.dataLayer=w.dataLayer||[],loaded=false,i;\nfunction load(){\nif(loaded)return;loaded=true;\nfor(var k=0;k<evs.length;k++)w.removeEventListener(evs[k],load,true);\nvar at=dl.length;\nfor(var e=0;e<dl.length;e++){if(dl[e]&&dl[e].event){at=e;break;}}\ndl.splice(at,0,{'gtm.start':new Date().getTime(),event:'gtm.js'});\nvar j=d.createElement('script');j.async=true;j.src=src;d.head.appendChild(j);\n}\nfor(i=0;i<evs.length;i++)w.addEventListener(evs[i],load,{capture:true,passive:true});\nvar push=dl.push;\ndl.push=function(){\nvar r=push.apply(dl,arguments);\nfor(var k=0;k<arguments.length;k++){if(arguments[k]&&now.indexOf(arguments[k].event)>=0)load();}\nreturn r;\n};\n})(window,document,\"https://events.tarvike.com/80zjrsgouuuf.js?d5x3pn=DxFIMjsqXjxUTEBMXSokVBBIR1teQRccWwEUBxkOGBdIFhoY\",[\"pointerdown\",\"touchstart\",\"keydown\",\"scroll\",\"wheel\",\"mousemove\"],[\"purchase\"]);"},{"id":"CookieConsent","data-culture":"FI","data-gcm-version":"2.0","src":"https://policy.app.cookieinformation.com/uc.js","async":true},{"id":"CookieConsentListener","src":"/js/cookie-consent-listener.js","defer":true}],"noscript":[{"tagPosition":"bodyOpen","innerHTML":"<iframe src=\"https://events.tarvike.com/ns.html?id=GTM-N29592MW\" height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\"></iframe>"}],"title":"Mönkijät, moottoripyörät, kelkat, veneet - Unelmiesi konekauppa!","bodyAttrs":{"id":"app"}}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false